import { useNavigate } from "react-router-dom";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { BotonPreguntaleAtlas } from "../../chat-atlas";
import { BannerVistaEjemplo } from "./components/BannerVistaEjemplo";
import { PropuestaCard } from "./components/PropuestaCard";
import { PROPUESTAS_EJEMPLO, RESUMEN_EJEMPLO } from "./datos/ejemplo";

/**
 * Pantalla Plan: la lista de propuestas que los agentes le arman a la marca
 * para esta semana, cada una con su justificación respaldada por un número
 * real del cliente. La compuerta que descarta las que no cumplen eso vive en
 * `PropuestaCard`, no acá — esta pantalla solo lista lo que le llega.
 */
export const PlanPage = () => {
  const navigate = useNavigate();

  return (
    <div className="p-8">
      <BannerVistaEjemplo />

      {/* El botón va en la fila del título, alineado a la derecha: no tapa
          nada y queda a la vista sin empujar el contenido hacia abajo. */}
      <div className="mt-4 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h1 className="text-[22px] font-semibold text-brand-black">Esta semana</h1>
          <p className="mt-1 text-[13px] text-[#02062B]/[0.55]">Lo que conviene hacer esta semana</p>
        </div>
        <BotonPreguntaleAtlas
          pantalla="Plan del estudio de marketing"
          detalle="Las propuestas de contenido de esta semana y las métricas de resumen."
        />
      </div>

      <div className="mt-5 grid grid-cols-3 gap-3">
        {RESUMEN_EJEMPLO.map((metrica) => (
          <div key={metrica.clave} className="rounded-2xl border border-[#02062B]/[0.08] bg-white p-4">
            <p className="text-[12px] text-[#02062B]/[0.55]">{metrica.clave}</p>
            <p className="mt-1 text-[20px] font-semibold text-brand-black">{metrica.valor}</p>
            <p
              className={`mt-1 flex items-center gap-1 text-[12px] font-medium ${
                metrica.sentido === "sube" ? "text-[#1D7A57]" : "text-[#C33B36]"
              }`}
            >
              {metrica.sentido === "sube" ? (
                <ArrowUpRight className="h-3.5 w-3.5" />
              ) : (
                <ArrowDownRight className="h-3.5 w-3.5" />
              )}
              {metrica.delta}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-6 flex flex-col gap-3">
        {PROPUESTAS_EJEMPLO.map((propuesta) => (
          <PropuestaCard
            key={propuesta.pieza_id}
            propuesta={propuesta}
            onVerPieza={(piezaId) => navigate(`/estudio-marketing/plan/${piezaId}`)}
          />
        ))}
      </div>
    </div>
  );
};

export default PlanPage;
